/**
 * Format số tiền theo chuẩn Việt Nam
 * @param {number|string} amount - Số tiền cần format
 * @returns {string} - Số tiền đã được format (ví dụ: "1.000.000 đ")
 */
export const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || amount === '') {
        return '0 đ';
    }
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(numAmount)) {
        return '0 đ';
    }
    return numAmount.toLocaleString('vi-VN') + ' đ';
};

/**
 * Format số điện thoại Việt Nam
 * @param {string|number} phone - Số điện thoại cần format
 * @returns {string} - Số điện thoại đã được format (ví dụ: "0123 456 789" hoặc "0123 4567 890")
 */
/**
 * Format điểm tích luỹ
 * @param {number|string} points - Số điểm cần format
 * @returns {string} - Số điểm đã được format (ví dụ: "1.250 điểm")
 */
export const formatPoints = (points) => {
    if (points === null || points === undefined || points === '') {
        return '0 điểm';
    }
    const num = typeof points === 'string' ? parseFloat(points) : points;
    if (isNaN(num)) {
        return '0 điểm';
    }
    return num.toLocaleString('vi-VN');
};

export const formatPhoneNumber = (phone) => {
    if (!phone) {
        return '-';
    }
    const phoneStr = phone.toString().trim();
    if (!phoneStr) {
        return '-';
    }

    // Loại bỏ tất cả ký tự không phải số
    const digitsOnly = phoneStr.replace(/\D/g, '');

    if (digitsOnly.length === 0) {
        return phoneStr; // Trả về nguyên bản nếu không có số nào
    }

    // Format theo chuẩn Việt Nam
    if (digitsOnly.length === 10) {
        // Số 10 chữ số: 0xxx xxx xxx
        return `${digitsOnly.slice(0, 4)} ${digitsOnly.slice(4, 7)} ${digitsOnly.slice(7)}`;
    } else if (digitsOnly.length === 11) {
        // Số 11 chữ số: 0xxx xxxx xxx
        return `${digitsOnly.slice(0, 4)} ${digitsOnly.slice(4, 8)} ${digitsOnly.slice(8)}`;
    } else {
        // Nếu không đúng độ dài, trả về nguyên bản
        return phoneStr;
    }
};
